import { Backend, IApi } from './backend'
import { AxiosResponse } from 'axios'
import { IRequest } from './index'
import IProduct from './../models/product'

export default class Product extends Backend {
  static getTableData(
    request: IRequest
  ): Promise<AxiosResponse<{ rows: IProduct[]; count: number }>> {
    const api: IApi = {
      url: '/api/product/tableData',
      method: 'get',
      data: { request }
    }
    return this.request<{ rows: IProduct[]; count: number }>(api)
  }
  static createOrUpdate(data: any): Promise<AxiosResponse<IProduct>> {
    const api: IApi = {
      url: '/api/product/createOrUpdate',
      method: 'post',
      data
    }
    return this.request<IProduct>(api)
  }
  static delete(id: number): Promise<AxiosResponse> {
    const api: IApi = {
      url: `/api/product/${id}`,
      method: 'delete'
    }
    return this.request(api)
  }
}
